import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import login from '../assets/images/login.png'

export const Login = ({ envData, isLocalEnvironment, isLoggedIn }) => {
  const redirectURL = window.location.origin
  const navigate = useNavigate()

  React.useEffect(() => {
    if (envData.REACT_APP_APP_ISONLINE === '0') {
      navigate('/auth/login')
    }
    if (isLoggedIn) {
      navigate('/console/dashboard')
    }
  })

  const emailLogin = () => {
    window.open(isLocalEnvironment + '/auth/login', '_self')
  }

  const googleLogin = () => {
    window.open(isLocalEnvironment + '/auth/google?url=' + redirectURL, '_self')
  }

  const facebookLogin = () => {
    window.open(isLocalEnvironment + '/auth/facebook?url=' + redirectURL, '_self')
  }
  const getLoginError = sessionStorage.getItem('loginError')
  return (
    <div className="trtui-auth-page-wrapper trtui-auth-bg-cover trtui-py-5 trtui-d-flex trtui-justify-content-center trtui-align-items-center trtui-min-vh-100">
      <div className="trtui-bg-overlay" />
      <div className="trtui-auth-page-content trtui-overflow-hidden trtui-pt-lg-5">
        <div className="trtui-container">
          <div className="trtui-row">
            <div className="trtui-col-lg-12">
              <div className="trtui-card trtui-overflow-hidden">
                <div className="trtui-row trtui-g-0">
                  <div className="trtui-col-lg-6" style={{ height: '20rem' }}>
                    <div
                      className="trtui-p-lg-5 trtui-p-4 trtui-auth-one-bg trtui-h-100"
                      style={{
                        backgroundImage: `url(${login})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                      }}
                    >
                      <div className="trtui-bg-overlay" style={{ opacity: '0.5' }} />
                      <div className="trtui-position-relative trtui-h-100 trtui-d-flex trtui-flex-column">
                        <div className="trtui-mb-4">
                          <a href="/" className="trtui-d-block">
                            <img
                              src={envData.REACT_APP_THEME_FAVICON}
                              alt="Login Page Logo"
                              className="trtui-img-fluid"
                              style={{ width: '3rem' }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="trtui-col-lg-6">
                    <div className="trtui-p-lg-5 trtui-p-4">
                      <div>
                        <h5 className="trtui-text-primary">Welcome Back !</h5>
                        <p className="trtui-text-muted">Sign in to continue.</p>
                      </div>
                      <div className="trtui-mt-6">
                        {envData.REACT_APP_APP_ISONLINE === '1' &&
                          envData.REACT_APP_GOOGLE_LOGIN === '1' && (
                            <button className="trtui-btn trtui-btn-light" onClick={googleLogin}>
                              <i className="ri-google-fill trtui-align-bottom trtui-text-danger" />{' '}
                              Google
                            </button>
                          )}{' '}
                        {envData.REACT_APP_APP_ISONLINE === '1' &&
                          envData.REACT_APP_FACEBOOK_LOGIN === '1' && (
                            <button className="trtui-btn trtui-btn-info" onClick={facebookLogin}>
                              <i className="ri-facebook-fill trtui-align-bottom" /> Facebook
                            </button>
                          )}{' '}
                        {envData.REACT_APP_LOCAL_LOGIN === '1' && (
                          <button className="trtui-btn trtui-btn-light" onClick={emailLogin}>
                            <i className="ri-mail-fill trtui-align-bottom trtui-text-primary" />{' '}
                            Email
                          </button>
                        )}
                      </div>
                      <div className="trtui-mt-2">
                        {getLoginError && (
                          <h5 className="trtui-text-danger">Opps! could not login</h5>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="trtui-footer">
        <div className="trtui-container">
          <div className="trtui-row">
            <div className="trtui-col-lg-12">
              <div className="trtui-text-center">
                <p className="trtui-mb-0">© 2024 TRT. Developed by Thulisha Reddy Technologies</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

Login.propTypes = {
  envData: PropTypes.object.isRequired,
  isLocalEnvironment: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
}
